import { render, staticRenderFns } from "./JobApplicationReviewForm.vue?vue&type=template&id=27cba847&scoped=true&"
import script from "./JobApplicationReviewForm.vue?vue&type=script&lang=js&"
export * from "./JobApplicationReviewForm.vue?vue&type=script&lang=js&"
import style0 from "./JobApplicationReviewForm.vue?vue&type=style&index=0&id=27cba847&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cba847",
  null
  
)

component.options.__file = "JobApplicationReviewForm.vue"
export default component.exports